export default __webpack_public_path__ + "static/media/panel-finishing.7198fd58.svg";